// redux provider must be imported before api provider, due to the execution order of the user store
// prettier-ignore
import { store } from 'providers/redux';

import { Provider as RollbarProvider } from '@rollbar/react'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'

import 'providers/i18n'
import 'providers/monaco/config'
import 'providers/jsep/config'

import { AbilityProvider } from 'providers/casl'
import { GraphQLProvider } from 'providers/graphql'
import { MaterialUiProvider } from 'providers/material-ui'
import { LocalizationProvider } from 'providers/mui-x'
import { ProductFruitsProvider } from 'providers/product-fruits/ProductFruitsProvider'
import { rollbarConfig } from 'providers/rollbar/config'
import { RouterProvider } from 'providers/router'
import { SnackbarProvider } from 'providers/snackbar'
import { TanstackQueryProvider } from 'providers/tanstack-query/TanstackQueryProvider'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <RollbarProvider config={rollbarConfig}>
    <ReduxProvider store={store}>
      <MaterialUiProvider>
        <SnackbarProvider>
          <TanstackQueryProvider>
            <GraphQLProvider>
              <AbilityProvider>
                <LocalizationProvider>
                  <ProductFruitsProvider />
                  <RouterProvider />
                </LocalizationProvider>
              </AbilityProvider>
            </GraphQLProvider>
          </TanstackQueryProvider>
        </SnackbarProvider>
      </MaterialUiProvider>
    </ReduxProvider>
  </RollbarProvider>,
)
